import { render, staticRenderFns } from "./ViewContributionPage.vue?vue&type=template&id=1395b19c&"
import script from "./ViewContributionPage.vue?vue&type=script&lang=js&"
export * from "./ViewContributionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports